import { useEffect, useRef, useState } from 'react';

export function useUpdateChecker(intervalMs = 60_000) {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const currentRef = useRef(null);
  const filePath = '/meta.json';

  // Capture meta shipped with the current page load
  useEffect(() => {
    // Optional: embed current meta at build time, or fetch once on mount
    fetch(filePath, { cache: 'no-store' })
      .then(r => r.json())
      .then((meta) => { currentRef.current = meta; })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    const id = setInterval(async () => {
      try {
        const res = await fetch(filePath, { cache: 'no-store' });
        const incoming = await res.json();
        const initialState = currentRef.current;
        if (
          initialState
          && (incoming.gitSha !== initialState.gitSha || incoming.buildTime !== initialState.buildTime)
        ) {
          setUpdateAvailable(true);
          clearInterval(id);
        }
      } catch (e) {
        console.log(e);
      }
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return { updateAvailable, reload: () => window.location.reload() };
}